import { useEntitlements } from '~/hooks/account';

export const useProfilePermissions = () => {
  const { hasAccessBilling, isOwner } = useEntitlements();

  const isBillingDisabled = !hasAccessBilling;

  return {
    isOwner,
    isBillingDisabled,
  };
};
